import Tooltip from "../../../../../Components/common/Tooltip/Tooltip";

const RadioInput = ({ label, name, tooltipText, value, onChange }) => {
  return (
    <div className="phishbox-settings__radio">
      <p className="phishbox-settings__radio__header">
        {label}
        {tooltipText && <Tooltip text={tooltipText} />}
      </p>
      <div className="phishbox-settings__radio__labels">
        <label>
          <input
            className="phishbox-settings__radio__input"
            type="radio"
            value={1}
            name={name}
            checked={value === 1}
            onChange={onChange}
          />
          <p>YES</p>
        </label>
        <label>
          <input
            className="phishbox-settings__radio__input"
            type="radio"
            value={0}
            name={name}
            checked={value === 0}
            onChange={onChange}
          />
          <p>NO</p>
        </label>
      </div>
    </div>
  );
};

export default RadioInput;
